'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useUnloadTrack } from "@/hooks/useUnloadTrack";
import { persistUtmTrackingParams, resolveUtmTrackingParams } from '@/lib/url-utils';
export const ClientHooks = () => {
  const $ = _c(2);
  useUnloadTrack();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  useEffect(_temp2, t1);
  return null;
};
function _temp() {
  if (!sessionStorage.getItem("landingPath")) {
    const path = window.location.pathname;
    if (!path.startsWith("/auth")) {
      sessionStorage.setItem("landingPath", path);
    }
  }
}
function _temp2() {
  if (window.location.pathname.startsWith("/auth")) {
    return;
  }
  if (Object.keys(resolveUtmTrackingParams()).length > 0) {
    return;
  }
  const searchParams = new URLSearchParams(window.location.search);
  persistUtmTrackingParams(searchParams);
}